import { mount_vue_app, read_app_config } from '../_partials/_app.js';
import App from '../jobs-app/app.vue';

(function () {
	const app_el = document.getElementById(`js-jobs-search-form`);
	if (!app_el) {
		return;
	}

	const config = read_app_config(app_el);

	mount_vue_app(app_el, () => ({
		component: App,
		props: {
			api_url: config.api_url,
			search_url: config.search_url,
			is_home: Boolean(config.is_home),
			lite: true,
			button_label: config.button_label,
			defaults: config.defaults,
		},
	}));
})();
